<template>
  <view class="popup">
    <ts-mask
      show="{{show && showMask}}"
      closeable="{{closeable}}"
      bind:close="close"
      externStyle="{{computedMaskStyle}}"
    />
    <view
      class="transition"
      wx:class="{{[lowerZIndex,position,className]}}"
      wx:style="{{externStyle}}"
    >
      <slot></slot>
    </view>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      showMask: {
        type: Boolean,
        value: true
      },
      closeable: {
        type: Boolean,
        value: true
      },
      position: {
        type: String,
        value: 'center'
      },
      externStyle: {
        type: Object,
        value: {}
      },
      maskStyle: {
        type: Object,
        value: {}
      },
      isDrawer: {
        type: Boolean,
        value: false
      },
      simple: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {}
    },

    computed: {
      className() {
        const key = this.show ? 'leave' : 'enter'
        const _className = this.position + '-' + key
        return _className
      },
      computedMaskStyle() {
        return {
          zIndex: this.isDrawer ? 550 : 650,
          ...this.maskStyle
        }
      },
      lowerZIndex() {
        return this.isDrawer ? 'drawer' : ''
      }
    },

    watch: {
      show(val) {
        if (val) {
          this.funShow()
        }
      }
    },

    methods: {
      close(e) {
        const closeType = e?.detail?.type
        if (!this.closeable) {
          return
        }
        this.triggerEvent('close', {
          type: closeType
        })
      },
      funShow() {
        this.triggerEvent('funShow')
      }
    },

    ready() {
      if (__mpx_mode__ == 'web') {
        if (this.simple) {
          const page = getCurrentPages().slice(-1)[0]?.$el || document.body
          page.appendChild(this.$el)
        } else document.body.appendChild(this.$el)
      }
    },

    detached() {
      if (__mpx_mode__ == 'web' && !this.simple) {
        if (document.body.contains(this.$el)) {
          document.body.removeChild(this.$el)
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .popup
    max-height 100%
    overflow-y auto
    touch-action none
  .center
    top 50%
    left 50%
  .top
    top 0
    left 0
    width 100%
  .bottom
    bottom 0
    left 0
    width 100%
  .left
    top 50%
    left 0
  .right
    top 50%
    right 0
  .transition
    position fixed
    transition-timing-function ease
    transition-duration 300ms
    transition-property opacity, transform, visibility
    touch-action none
    z-index 700
  .drawer
    z-index 600
  .fade-enter-to, .fade-leave
    opacity 1
  .fade-enter, .fade-leave-to
    opacity 0
  .center-enter, .center-leave-to
    transform translate3d(-50%, -50%, 0) scale(0.9)
    opacity 0
    visibility hidden
  .center-enter-to, .center-leave
    transform translate3d(-50%, -50%, 0)
    opacity 1
    visibility visible
  .bottom-enter, .bottom-leave-to
    transform translate3d(0, 100%, 0)
  .top-enter, .top-leave-to
    transform translate3d(0, -100%, 0)
  .left-enter, .left-leave-to
    transform translate3d(-100%, -50%, 0)
  .left-enter-to, .left-leave
    transform translate3d(0, -50%, 0)
  .right-enter, .right-leave-to
    transform translate3d(100%, -50%, 0)
  .right-enter-to, .right-leave
    transform translate3d(0, -50%, 0)
</style>
<script  type='application/json' lang='json'>
{
 "component": true,
 "usingComponents": {
    "ts-mask": "../ts-mask/index",
  }
}
</script>

